<template>
  <div class="career-category">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách ngành nghề tuyển dụng</h6>
          <a-button type="primary" class="ml-20" @click="createCategory"
            >Thêm mới</a-button
          >
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChangePage"
        rowKey="id"
      >
        <template slot="created_at" slot-scope="row">
          {{ row | formatDate }}
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <a-button
              shape="circle"
              icon="edit"
              size="small"
              @click="updateCategory(row)"
            />
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="remove(row)"
            >
              <template slot="title">
                <p>Xóa {{ row.title }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
    <ControllerCareerCategory
      :visible="visibleController"
      :category="selectedCategory"
      @reload="loadData"
      @close="visibleController = false"
    />
  </div>
</template>

<script>
import {
  fetchCategory,
  removeCategory,
} from "@/services/landing-page/career/career-category";
import ControllerCareerCategory from "./ControllerCategory";
export default {
  name: "CareerCategory",
  components: {
    ControllerCareerCategory,
  },
  data() {
    return {
      pagination: {
        total: 0,
        pageSize: 10,
      },
      currentPage: 1,

      dataSource: [],
      columns: [
        {
          title: "Tên",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
          class: "font-semibold",
          width: "200px",
        },
        {
          title: "Ngày tạo",
          dataIndex: "created_at",
          scopedSlots: { customRender: "created_at" },
          width: "150px",
        },
        {
          title: "",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: "130px",
        },
      ],

      visibleController: false,
      selectedCategory: null,
    };
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.visibleController = false
      try {
        this.callingAPI = true;
        const params = {
          per_page: this.pagination.pageSize,
          page: this.currentPage,
        };
        const response = await fetchCategory(params);
        this.dataSource = response.data.data;
        this.pagination.total = response.data.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async remove(row) {
      try {
        await removeCategory(row.id);
        await this.loadData();
        this.callingAPI = false;
        this.$notification.success({
          message: "Thành công",
          description: "Xóa thành công.",
        });
      } catch (error) {
        this.callingAPI = false;
        this.callingAPI = false;
        this.$notification.erorr({
          message: "Thất bại",
          description: "Xóa thất bại.",
        });
      }
    },

    async handleTableChangePage(pagination) {
      this.currentPage = pagination.current;
      await this.loadData();
    },

    createCategory() {
      this.selectedCategory = null;
      this.visibleController = true;
    },

    updateCategory(row) {
      this.selectedCategory = row;
      this.visibleController = true;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>